import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComboBox, NoResult, BookMarkStore, Alert, ComPhoto } from '../../../js/ComponentManager'
/* 개발담당:양유빈
 * 화면기능: 매장검색 화면(건물,층,호수로 검색)
 * 세부설명:
*/

export class StoreList extends Component {
    static displayName = StoreList.name;
    //검색조건 다시 셋업
    constructor(props) {
        super(props);
        this.state = {
            BldList: [],              // 빌딩콤보 리스트
            FlrList: [],              // 층콤보 리스트
            WholeList: [],             // 상가정보 리스트

            Bld_Code: "",
            Flr_Code: "",
            Whole_No_Name:"",
            Whole_Name: "",
            Title: "건물을 선택하여 주세요.",
            Content: "",
            Setting: false
            
        };
        this.CsName = Big3Common.ContentState;
        this.refStoreList = React.createRef();
        this.ref_BuyerPopup = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        
        this.handle_KeyUp = this.handle_KeyUp.bind(this);
        this.handle_Click = this.handle_Click.bind(this);
        this.handleStore_Click = this.handleStore_Click.bind(this);       

    }
    //초기화, 
    async componentDidMount() {
         
        await this.DefaultData();

        //아래는 검색조건 결과에서 매장 상세로 이동 후 다시 셋업하는 과정
        //건물콤보 값이 있을때
        const propBld_Code = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Bld_Code, "");
        if (propBld_Code !== "") {
            await this.handleChangeGen("Bld_Code", propBld_Code);  
        }
        //층수콤보 값이 있을때
        const propFlr_Code = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Flr_Code, "");
        if (propFlr_Code !== "") {
            await this.handleChangeGen("Flr_Code", propFlr_Code)
        }
        //호수 값이 있을때
        const propWhole_No_Name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.Whole_No_Name, "");
        if (propWhole_No_Name !== "") {
            await this.handleChangeGen("Whole_No_Name", propWhole_No_Name);
        }
       
        //검색어가 있을때
        const SearchText = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "");
        let WholeList = [];
        if (SearchText !=="") {
            document.querySelector(".search_box input").value = SearchText;
            WholeList = await this.GetWholeSearch(propBld_Code, propFlr_Code, propWhole_No_Name, SearchText);
        }
        else {
            if (propBld_Code !== "") {
                WholeList = await this.GetWholeSearch(propBld_Code, propFlr_Code, propWhole_No_Name, SearchText);
            }
        }
        this.setState({
            Bld_Code: propBld_Code,
            Flr_Code: propFlr_Code,
            Whole_No_Name: propWhole_No_Name,
            WholeList: WholeList,
            Whole_Name: SearchText
        });
        
    }
    //건물정보, 층 정보 호출
    TempFlrList = [];
    async DefaultData() {
        try {
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {

                const DataSet = JSON.parse(Data.multiDataTable);
                const BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;

                this.setState({
                    BldList: BldList,                    
                });
            }
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
    }
    //검색실행
    async GetWholeSearch(BldCode, FlrCode, WholeNoName, Wholename) {
        try {
           
            let Model = {
                Bld_Code: BldCode,
                flr_Code: FlrCode,
                Whole_No_Name: WholeNoName.replaceAll('호', ''),
                whole_name: Wholename
            };
            if (BldCode === "" && Wholename === "") {
                return [];
            }
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post("api/Common/Common/GetBldWholeSearchPlatform", Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = Data.objectData
                if (DataSet === undefined) {
                    DataSet = JSON.parse(Data.dataTable);
                }
                return DataSet;
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetWholeSearch :", e);
        }
        finally
        {
            Big3Common.Util.LoadingOff();
        }
    }
    //콤보이벤트 생성
    async handleChangeGen(ComboId, CodeValue) {
        let Event = {
            target: {
                id: ComboId,
                value: CodeValue
            }
        }
        await this.handleChange(Event);
    }
    //콤보이벤트 실행
    async handleChange(event) {

        let tagId = event.target.id;
        let value = event.target.value.trim();
        if (tagId === "Bld_Code") {
            let mapList = [];
            this.TempFlrList.map(data => {
                if (data.bld_code === value) {
                    mapList.push(data);
                }
                return false;
            });
            
            //층코드 초기화             
            this.setState({
                Bld_Code: value,
                FlrList: mapList,
                Flr_Code: "",
                Whole_No_Name: ""
            });
        }
        else if (tagId === "Flr_Code") {
            let WholeList = await this.GetWholeSearch(this.state.Bld_Code, value, "", this.state.Whole_Name);
            this.setState({
                Bld_Code: this.state.Bld_Code,
                Flr_Code: value,
                Whole_No_Name: "",
                WholeList: WholeList
            });
        }
        else {
            this.setState({
                Bld_Code: this.state.Bld_Code,
                Flr_Code: this.state.Flr_Code,
                Whole_No_Name: value
            });
        }
        return false;
    }
    //호수 키 이벤트
    async handle_KeyUp(event) {
        if (event.keyCode === 13) {
            if (this.state.Bld_Code === "" && this.state.Flr_Code === "") {
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            let WholeList = await this.GetWholeSearch(this.state.Bld_Code, this.state.Flr_Code, this.state.Whole_No_Name, this.state.Whole_Name);
            this.setState({ WholeList: WholeList });
        }
        event.preventDefault();
    }
    
    //검색홈 이동
    handle_Click() {
        //이동시 키워드는 삭제 후 이동
        if (this.props.SetKeyWord !== undefined) {
            this.props.SetKeyWord("");
        }
        this.props.RenderComponent("SearchList");
        return false;
    }
    //도매상세 이동
    handleStore_Click(event, list) {
         
        if (list.uid !== undefined && list.uid !== null && list.uid !== "") {
            this.props.RenderComponent('StoreDtl', {
                [this.CsName.Uid]: list.uid,
                [this.CsName.BackUrl]: "StoreList",
                [this.CsName.Bld_Code]: this.state.Bld_Code,
                [this.CsName.Flr_Code]: this.state.Flr_Code,
                [this.CsName.Whole_No_Name]: this.state.Whole_No_Name,
                [this.CsName.SearchText]: this.state.Whole_Name
            });
        }
        else { 
            this.setState({
                Title: "매장안내",
                Content: `${list.whole_name}는 플랫폼에 가입된 도매가 아닙니다.`
            });
            Big3Common.ModalAlert(bootstrap, "MessageAlert");
        }
        
        event.preventDefault();
    }
    //검색 공통에서(SearchText) 넘어온 조건 할당 및 실행(Index 에서 ref로 호출)
    async SetSearchText(SearchText) {
        if (SearchText !== undefined && SearchText !== "") {
            let WholeList = await this.GetWholeSearch(this.state.Bld_Code, this.state.Flr_Code, this.state.Whole_No_Name, SearchText);
            this.setState({ WholeList: WholeList, Whole_Name: SearchText });
            //로그기록
            Big3Common.RegisterTrackingLog({
                [Big3Common.ContentState.Page_cd]: "SW",
                [Big3Common.ContentState.Basket_Yn]: "N"
            });
        }
        else {
            let WholeList = await this.GetWholeSearch(this.state.Bld_Code, this.state.Flr_Code, this.state.Whole_No_Name, "");
            this.setState({ WholeList: WholeList, Whole_Name: "" });
        }
    }
    Storerender() {
        if (this.state.WholeList.length === 0) {
            return false;
        }
        let DataList = this.state.WholeList;
        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        
        return (
            DataList.map(list =>
                <div className="alert_content_v2 alert_content" key={list.whole_code}>
                    <div className="alert_img" onClick={(e) => { this.handleStore_Click(e,list) } }>
                        <ComPhoto className="alert_img_in" Photo={Big3Common.Util.isEmptyOrNull(list.photo) === true ? "" : VirtualRoot + list.photo} />
                    </div>
                    <div className="alert_txt">
                        <div className="shop_name">{list.whole_name}</div>
                        <div className="shop_address sd_v2">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>
                        <div className="shop_address">상품등록수: {Big3Common.Util.Money(list.goods_cnt)}건</div>
                        <BookMarkStore
                            Whole_Code={list.whole_code}
                            HeartOn={list.bookmark_yn === "Y" ? true : false}
                        />
                        <Link to={`/Chat/LiveChat/Index?uid=${list.uid}`}>
                            <div className="order_btn or_btn4">채팅하기</div>
                        </Link>
                        
                        <div className="shop_go" onClick={(e) => { this.handleStore_Click(e, list)}}></div>
                    </div>
                </div>
                
            )
        )
    }
    render() {
        let Storerender = this.Storerender();
        return (
            <div ref={this.refStoreList}>
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap" onClick={() => { this.handle_Click() }}>상품</div></div>
                    <div className="n_tap"><div className="alert_tap tap_on" >매장</div></div>
                </div>
                <div  className="a_margin d_padding container_box">
                    <div className="title_box">
                        <div className="title">상가별 검색</div>
                    </div>
                    <div className="shop_search_box">
                        <ComboBox id="Bld_Code"
                            ComboChange={this.handleChange}
                            emptyText="건물"
                            textName="bld_name"
                            valueName="bld_code"
                            setValue={this.state.Bld_Code}
                            optionList={this.state.BldList}
                        />
                        <ComboBox id="Flr_Code"
                            ComboChange={this.handleChange}
                            emptyText="층수"
                            textName="flr_name"
                            valueName="flr_code"
                            optionList={this.state.FlrList}
                            setValue={this.state.Flr_Code}
                        />
                        <div className="shop_search_input_box">
                            <input type="text"
                                className="form-control"
                                id="Whole_No_Name"
                                maxLength="10"
                                placeholder="호수검색"
                                onChange={this.handleChange}
                                value={this.state.Whole_No_Name}
                                onKeyUp={this.handle_KeyUp}
                            />
                            <div className="search_icon" onClick={() => { this.SetSearchText() }}></div>
                        </div>
                    </div>
                    <div className="title_box">
                        <div className="title">클로디매장</div>
                    </div>
                    {Storerender}
                    <NoResult
                        Visible={this.state.WholeList.length === 0 ? true : false}
                        Top={"60%"}
                    />
                    <Alert
                        id="MessageAlert"
                        title={this.state.Title}
                        content={this.state.Content}
                    />
                </div>
            </div>
        );
    }
}
